var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 172,
    viewBox: "0 0 206 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 5,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 5,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 5,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 5,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 5,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 5,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 5,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 5,
    r: 5,
    fill: "#6AB8FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 5,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 5,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 5,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 5,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 5,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 5,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 5,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 23,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 23,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 23,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 23,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 23,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 23,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 23,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 23,
    r: 5,
    fill: "#6AB8FF"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 23,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 23,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 23,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 23,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 23,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 23,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 23,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 41,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 41,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 41,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 41,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 41,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 41,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 41,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 41,
    r: 5,
    fill: "#6AB8FF"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 41,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 41,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 41,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 41,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 41,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 41,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 41,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 59,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 59,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 59,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 59,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 59,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 59,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 59,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 59,
    r: 5,
    fill: "#6AB8FF"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 59,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 59,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 59,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 59,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 59,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 59,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 59,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 77,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 77,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 77,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 77,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 77,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 77,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 77,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 77,
    r: 5,
    fill: "#6AB8FF"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 77,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 77,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 77,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 77,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 77,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 77,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 77,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 95,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 95,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 95,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 95,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 95,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 95,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 95,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 95,
    r: 5,
    fill: "#6AB8FF"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 95,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 95,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 95,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 95,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 95,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 95,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 95,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 113,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 113,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 113,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 113,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 113,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 113,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 113,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 113,
    r: 5,
    fill: "#6AB8FF"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 113,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 113,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 113,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 113,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 113,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 113,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 113,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 131,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 131,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 131,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 131,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 131,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 131,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 131,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 131,
    r: 5,
    fill: "#6AB8FF"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 131,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 131,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 131,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 131,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 131,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 131,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 131,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 149,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 149,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 149,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 149,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 149,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 149,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 149,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 149,
    r: 5,
    fill: "#6AB8FF"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 149,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 149,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 149,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 149,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 149,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 149,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 149,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 167,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 167,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 167,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 167,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 167,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 167,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 167,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 167,
    r: 5,
    fill: "#6AB8FF"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 167,
    r: 4.5,
    fill: "#6AB8FF",
    fillOpacity: 0.81
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 167,
    r: 4,
    fill: "#6AB8FF",
    fillOpacity: 0.6
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 167,
    r: 3.5,
    fill: "#6AB8FF",
    fillOpacity: 0.4
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 167,
    r: 3,
    fill: "#6AB8FF",
    fillOpacity: 0.3
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 167,
    r: 2.5,
    fill: "#6AB8FF",
    fillOpacity: 0.29
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 167,
    r: 2,
    fill: "#6AB8FF",
    fillOpacity: 0.26
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 167,
    r: 1.5,
    fill: "#6AB8FF",
    fillOpacity: 0.25
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.adf7817bdbec59bbde2b74f6746dfb7d.svg";
export { ForwardRef as ReactComponent };